var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_931_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9157 28.2656L28.6032 24.5156C28.2481 24.3563 27.8534 24.3228 27.4786 24.42C27.1038 24.5172 26.7692 24.74 26.525 25.0547L22.8438 29.7891C17.0664 26.9217 12.4169 22.0276 9.69297 15.9461L14.1906 12.0711C14.4902 11.8146 14.7023 11.4623 14.7947 11.0676C14.8871 10.6729 14.8548 10.2573 14.7027 9.88362L11.1402 1.13362C10.9733 0.730812 10.6781 0.401935 10.3055 0.203695C9.93294 0.0054552 9.50632 -0.0497211 9.09922 0.0476803L1.38047 1.92268C0.987977 2.01809 0.637795 2.25071 0.387077 2.58259C0.136359 2.91447 -9.0414e-05 3.326 4.49484e-08 3.75002C4.49484e-08 23.7891 15.4301 40 34.4375 40C34.8404 40.0003 35.2316 39.8567 35.547 39.5928C35.8624 39.3289 36.0836 38.9602 36.1742 38.5469L37.9555 30.4219C38.0474 29.9913 37.9939 29.5404 37.8041 29.1469C37.6143 28.7533 37.3001 28.4417 36.9157 28.2656Z",
    fill: "#EAB9F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.48e45682ce3a13f2d605dbe32738e78e.svg";
export { ForwardRef as ReactComponent };